import { __assign } from '../../node_modules/tslib/tslib.es6.js';
import css from '../../node_modules/@styled-system/css/dist/index.esm.js';
import { Box } from '../layout/Box.js';
import '../layout/Stack.js';
import '../layout/AnimatedBox.js';
import '../layout/Scrollbars.js';
import React__default from 'react';
import styled from 'styled-components';
import { visuallyHiddenStyle } from '../../utils/visuallyHidden.js';
var Label = styled.label({
  cursor: "pointer",
  userSelect: "none",
  display: "inline-block",
  "-webkit-tap-highlight-color": "transparent"
});
var Input = styled.input(visuallyHiddenStyle);
var Track = styled(Box)(function (_a) {
  var isChecked = _a.isChecked;
  return css({
    width: "51px",
    height: "31px",
    borderRadius: "31px",
    borderWidth: "2px",
    borderStyle: "solid",
    borderColor: isChecked ? "green.300" : "grey.6",
    backgroundColor: isChecked ? "green.300" : "grey.6",
    transition: "background-color border-color 150ms"
  });
});
var Thumb = styled(Box)(function (_a) {
  var isChecked = _a.isChecked;
  return css({
    width: "27px",
    height: "27px",
    borderRadius: "27px",
    backgroundColor: "white",
    boxShadow: "0px 3px 8px rgba(0, 0, 0, 0.15), 0px 3px 1px rgba(0, 0, 0, 0.06)",
    transform: isChecked ? "translateX(20px)" : undefined,
    transition: "transform 300ms"
  });
});
var Switch = React__default.forwardRef(function (props, ref) {
  var checked = props.checked,
    defaultChecked = props.defaultChecked,
    onChange = props.onChange;
  var _a = React__default.useState(defaultChecked || false),
    isChecked = _a[0],
    setChecked = _a[1];
  React__default.useEffect(function () {
    setChecked(checked || defaultChecked || false);
  }, [checked, defaultChecked]);
  var handleChange = React__default.useCallback(function (e) {
    if (checked === undefined) {
      setChecked(e.target.checked);
    }
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
  }, [checked, onChange]);
  return React__default.createElement(Label, null, React__default.createElement(Input, __assign({}, props, {
    type: "checkbox",
    onChange: handleChange,
    ref: ref
  })), React__default.createElement(Track, {
    isChecked: isChecked
  }, React__default.createElement(Thumb, {
    isChecked: isChecked
  })));
});
export { Switch };